import { IBlockLayout } from '@fox/blocks/contracts/work-bench';
import { useBlockComponentContext } from './form-root/block-component-context';

export function RenderBlockComponent({ id, props, type }: IBlockLayout) {
	const { getBlockComponent } = useBlockComponentContext();
	const Comp = getBlockComponent?.(type);
	if (!Comp) {
		return <div style={{ backgroundColor: 'red' }}>{type}</div>;
	}
	return <Comp props={{ ...props }} id={id} key={id} type={type} />;
}
